export const isMarketplaceVitrinePublicSearchEnabled = () =>
  import.meta.env.VITE_ENABLE_MARKETPLACE_VITRINE_SEARCH === '1'
